<div class="with-floating-button">
    <div class="content" *ngIf="message">
        <page-header
                [title]="(isCreation ? 'admin.bibliotheque.notifications.message.detail.creation' : 'admin.bibliotheque.notifications.message.detail.modification') | translate"
                [listeItems]="listeTabItems"
                (onGoBack)="onGoBack()">
        </page-header>
        <div [hidden]="selectedItem?.code !== Onglets.GENERALITES">
            <form #form="ngForm" *ngIf="message">
                <mat-card>
                    <mat-card-title>
                        <span [translate]="'admin.bibliotheque.notifications.title'"></span>
                    </mat-card-title>
                    <mat-card-content>
                        <fieldset>
                            <div class="row">
                                <custom-input
                                        ngDefaultControl
                                        id="titre"
                                        name="titre"
                                        [(ngModel)]="message.titre"
                                        customType="input"
                                        libelle="admin.bibliotheque.notifications.message.labels.titre"
                                        [required]="true"
                                        [maxlength]="30">
                                </custom-input>
                                <custom-input
                                        ngDefaultControl
                                        id="type"
                                        name="type"
                                        [(ngModel)]="message.type"
                                        customType="select"
                                        [selectOptions]="listeTypesMessage"
                                        optionValue="id"
                                        optionDisplay="libelle"
                                        libelle="admin.bibliotheque.notifications.message.labels.type"
                                        [required]="true">
                                </custom-input>
                            </div>
                            <div class="row" *ngIf="message.type === TypeMessageNotif.EMAIL">
                                <custom-input
                                        ngDefaultControl
                                        id="sujet"
                                        name="sujet"
                                        [(ngModel)]="message.sujet"
                                        customType="input"
                                        libelle="admin.bibliotheque.notifications.message.labels.sujet"
                                        [required]="true"
                                        [maxlength]="100">
                                </custom-input>
                                <custom-input
                                        ngDefaultControl
                                        id="globalise"
                                        name="globalise"
                                        [ngModel]="message.globalise"
                                        [(customModel)]="message.globalise"
                                        customType="checkbox"
                                        libelle="admin.bibliotheque.notifications.message.labels.globalise"
                                        [postTooltip]="'admin.bibliotheque.notifications.message.detail.tooltipGlobalise' | translate">
                                </custom-input>
                            </div>
                            <div class="row" *ngIf="message.type === TypeMessageNotif.EMAIL">
                                <custom-input
                                        ngDefaultControl
                                        id="typePushNotification"
                                        name="typePushNotification"
                                        [(ngModel)]="message.typePushNotification"
                                        customType="select"
                                        [selectOptions]="listeTypesPushNotification"
                                        optionValue="id"
                                        optionDisplay="libelle"
                                        libelle="admin.bibliotheque.notifications.message.labels.typePushNotification">
                                </custom-input>
                            </div>
                            <div class="row" *ngIf="message.type === TypeMessageNotif.EMAIL">
                                <tinymce-input
                                        ngDefaultControl
                                        name="corpsHtml"
                                        [(ngModel)]="message.corps"
                                        [libelle]="'admin.bibliotheque.notifications.message.labels.corps'"
                                        [required]="true"
                                        [tinymceConfig]="tinymceConfigCorps">
                                </tinymce-input>
                            </div>
                            <div class="row" *ngIf="message.type === TypeMessageNotif.CONFIRMATION">
                                <custom-input
                                        ngDefaultControl
                                        id="corps"
                                        name="corps"
                                        [(ngModel)]="message.corps"
                                        customType="textarea"
                                        rCol="10"
                                        libelle="admin.bibliotheque.notifications.message.labels.corps"
                                        [required]="true">
                                </custom-input>
                            </div>
                        </fieldset>
                    </mat-card-content>
                </mat-card>
            </form>
        </div>

        <floating-button [listeActions]="listeActions" [isPending]="isSaving"></floating-button>
    </div>

    <please-wait class="content" *ngIf="!message"></please-wait>
</div>